var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fff","d":"M535.655 60.083C529.374 36.433 510.868 17.807 487.371 11.486C444.781 0 274 0 274 0C274 0 103.22 0 60.629 11.486C37.132 17.808 18.626 36.433 12.345 60.083C0.932999 102.95 0.932999 192.388 0.932999 192.388C0.932999 192.388 0.932999 281.826 12.345 324.693C18.626 348.343 37.132 366.193 60.629 372.514C103.22 384 274 384 274 384C274 384 444.78 384 487.371 372.514C510.868 366.193 529.374 348.343 535.655 324.693C547.067 281.826 547.067 192.388 547.067 192.388C547.067 192.388 547.067 102.95 535.655 60.083V60.083ZM218.145 273.591V111.185L360.884 192.39L218.145 273.591V273.591Z"}));
}

Youtube.defaultProps = {"width":"548","height":"384","fill":"none","viewBox":"0 0 548 384"};

module.exports = Youtube;

Youtube.default = Youtube;
